import { NotificationInfo } from "@/services/notification-service/entity/NotificationEntity";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import cloneDeep from "lodash/cloneDeep";
import { INotificationStore } from "./NotificationModel";

const initialState: INotificationStore = {
  notifications: [],
};

export const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    addNotification: (
      state: INotificationStore,
      action: PayloadAction<NotificationInfo[]>
    ) => {
      let notifications: NotificationInfo[] = state.notifications
        ? cloneDeep(state.notifications)
        : [];
      notifications = notifications.concat(action.payload);
      state.notifications = cloneDeep(notifications);
    },
    removeNotification: (
      state: INotificationStore,
      action: PayloadAction<string>
    ) => {
      const notifications: NotificationInfo[] = state.notifications
        ? (state.notifications || []).filter((item: NotificationInfo) => item.guid !== action.payload)
        : [];
      state.notifications = cloneDeep(notifications);
    },
    resetNotification: (
      state: INotificationStore
    ) => {
      state.notifications = [];
    },
  },
});

export const { addNotification, removeNotification, resetNotification } = notificationSlice.actions;

export default notificationSlice.reducer;
